import React from 'react';
import { Link } from 'react-router-dom';
import { FaClipboardList } from 'react-icons/fa';
import './PostJobCtaSection.css';

import imageJobDone from "../../../assets/images/imgJoneDone.jpg";

const PostJobCtaSection = ({ 
    image,
    titleMain, 
    titleHighlight, 
    subtitle, 
    buttonText 
}) => {
    
    const displayImage = image || imageJobDone;
    // Note: Added space after DONE. to ensure separation from NO FUSS
    const tMain = titleMain || "POST A JOB & GET IT DONE."; 
    const tHighlight = titleHighlight || "NO FUSS";
    const sub = subtitle || "Post a job and wait for highly rated tradies to contact you.";
    const btnText = buttonText || "Post a Job";

    return (
        <section className="pjs-section">
            <div className="bs-container">
                <div className="pjs-wrapper">
                    
                    {/* Left Side: Content */}
                    <div className="pjs-content">
                        
                        <div className="pjs-icon-circle">
                            <FaClipboardList />
                        </div>

                        <h2 className="pjs-title">
                            {/* These are now inline spans so they flow like a sentence */}
                            <span className="pjs-title-dark">{tMain} </span>
                            <span className="pjs-title-blue">{tHighlight}</span>
                        </h2>

                        <p className="pjs-subtitle">
                            {sub}
                        </p>

                        <Link to="/select-role" className="pjs-btn">
                            {btnText}
                        </Link>
                    </div>

                    {/* Right Side: Image */}
                    <div className="pjs-image-container">
                        <img src={displayImage} alt="Post a job" className="pjs-image" />
                    </div>

                </div>
            </div>
        </section>
    );
};

export default PostJobCtaSection;